import Link from 'next/link';
import FaIcon, { faChevronLeft } from '../../../../components/icon/FaIcon/FaIcon';
import { ImageView } from '../../../../components/ui';
import MediaPlayer from '../../../../components/ui/MediaPlayer/MediaPlayer';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { MessageDetail as MessageDetailType } from '../../types';
import styles from './MessageDetail.module.scss';

export interface MessageDetailProps {
  message: MessageDetailType;
  backToListPath: string;
  formatDate: (date: string) => string;
}

/*:
 * メッセージ詳細
 * デザイン共通
 */

function MessageDetail({ message, backToListPath, formatDate }: MessageDetailProps) {
  // variantに応じてスタイルを決定
  const currentStyles = styles;

  return (
    <>
      <article>
        <header>
          <div className={currentStyles.itemDate}>{formatDate(message.sendedAt)}</div>
          <div className={utilsStyles.mtXSmall}>
            {!message.isArtist && (
              <div className={`${currentStyles.profile} ${utilsStyles.alignCenter}`}>
                {message.fromImageUrl && (
                  <div className={currentStyles.profileImage}>
                    <ImageView src={message.fromImageUrl} alt={message.fromName} isCircled />
                  </div>
                )}
                <div className={currentStyles.profileDetail}>
                  <p className={`${currentStyles.profileName} ${utilsStyles.textBold} ${utilsStyles.textEllipsis}`}>
                    {message.fromName}
                  </p>
                </div>
              </div>
            )}
          </div>
          <hr className={`${utilsStyles.mtXSmall} ${utilsStyles.grayBgColor}`} />
          <h2 className={`${currentStyles.itemTitle} ${utilsStyles.mtXSmall} ${utilsStyles.textBold}`}>
            {message.title}
          </h2>
        </header>
        <div
          className={`${utilsStyles.textSmall} ${utilsStyles.textHtml} ${utilsStyles.mtMedium}`}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: message.body }}
        />
        {message.files.map((file, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <div className={utilsStyles.mtSmall} key={index}>
            {file.videoUrl ? (
              <MediaPlayer src={file.videoUrl} />
            ) : (
              <ImageView src={file.imageUrl} alt={'image'} isFreeSize />
            )}
          </div>
        ))}
      </article>
      <div className={`${utilsStyles.centeredVertical} ${utilsStyles.mtMedium}`}>
        <Link href={{ pathname: backToListPath }} className={utilsStyles.textLinkArrow}>
          <FaIcon icon={faChevronLeft} size={'sm'} />
          &nbsp;メッセージ一覧へ
        </Link>
      </div>
    </>
  );
}

export default MessageDetail;
